export class SkechersCompareModelReq {

    poNumber: string;
    size: string;
    oldexFactoryDate: string;
    newexFactoryDate: string;
    oldQuantity: number;
    newQuantity: number;
    olddeliveryAddress: string;
    newdeliveryAddress: string;

    constructor(
        poNumber: string,
        size: string,
        oldexFactoryDate: string,
        newexFactoryDate: string,
        oldQuantity: number,
        newQuantity: number,
        olddeliveryAddress: string,
        newdeliveryAddress: string,
    ) {

        this.poNumber = poNumber
        this.size = size
        this.oldexFactoryDate = oldexFactoryDate
        this.newexFactoryDate = newexFactoryDate
        this.oldQuantity = oldQuantity
        this.newQuantity = newQuantity
        this.olddeliveryAddress = olddeliveryAddress
        this.newdeliveryAddress = newdeliveryAddress
    }

}